/*
  Услуги выбранного месяца - правая колонка страницы «Как сформировался долг».

  Графы те же, что в итогах страницы и в отчёте 1С: на начало, начислено,
  корректировка, оплачено, на конец. В макете, выбранном владельцем 05.10.2026,
  корректировка была сложена с начислением; здесь она отдельной графой, потому
  что складывать суммы кабинет не может (`api/format.js` - строки только для
  показа), а «начислено» в итогах и в месяце обязано значить одно и то же.

  Пустая графа показывается прочерком, а не нулём: в месяце, где за отчётный
  период ничего не начисляли и не платили, ряд нулей прячет единственную
  значащую цифру - долг.
*/

import { monthTitle, money } from '../api/format.js'
import DebtMonthPenalty from './DebtMonthPenalty.jsx'

function Amount({ value, label, strong = false }) {
  const shown = Number(value) ? money(value) : '-'
  return (
    <td className="table__num" data-label={label}>
      {strong ? <b>{shown}</b> : shown}
    </td>
  )
}

function Cells({ line }) {
  return (
    <>
      <Amount value={line.opening} label="На начало" />
      <Amount value={line.accrued} label="Начислено" />
      <Amount value={line.adjustment} label="Корректировка" />
      <Amount value={line.paid} label="Оплачено" />
      <Amount value={line.closing} label="На конец" strong />
    </>
  )
}

export default function DebtMonthDetail({ month, penaltyMonth = null, penaltyNotice = null }) {
  if (!month) return null
  return (
    <section className="card debt-detail">
      <h2 className="section__title">{monthTitle(String(month.period).slice(0, 7))}</h2>
      <div className="debt-detail__scroll">
      <table className="table">
        <thead>
          <tr>
            <th>Услуга</th>
            <th className="table__num">На начало</th>
            <th className="table__num">Начислено</th>
            <th className="table__num">Корректировка</th>
            <th className="table__num">Оплачено</th>
            <th className="table__num">На конец</th>
          </tr>
        </thead>
        <tbody>
          {month.services.map((line) => (
            <tr key={line.service}>
              <td>{line.service}</td>
              <Cells line={line} />
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="debt-detail__total">
            <td>Итого за месяц</td>
            <Cells line={month} />
          </tr>
        </tfoot>
      </table>
      </div>
      <DebtMonthPenalty month={penaltyMonth} notice={penaltyNotice} />
    </section>
  )
}
